<style lang="less">
@import "detailsH2H.less"; // 引入公共LESS文件
</style>
<template>
  <div>
    <div class="data-loading" style="padding: 20vh 0 50vh 0;" v-if="logdingFlag()">
      <van-loading vertical>{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</van-loading>
    </div>
    <div
      v-if="!loading && league && match && matchId"
      class="h2hWarp flex flex-warp"
    >
      <!-- 暂无数据 -->
      <DefaultPic
        v-if="
          !recentTwentyH2hOriginData.length &&
          !recentTwentyHomeOriginData.length &&
          !recentTwentyAwayOriginData.length &&
          !sameLuckHomeOriginData.length &&
          !sameLuckAwayOriginData.length &&
          !fixtureHome.length &&
          !fixtureAway.length
        "
      />
      <!-- h2h -->
      <div class="warp-item" v-if="recentTwentyH2hOriginData.length">
        <h1 class="flex flex-pack-justify">
          <div>{{ langConfig.details[langConfig.curLang]['H2H']['H2H_MATCHES'] }}</div>
          <el-select
            v-model="h2hLastSelected"
            placeholder="请选择"
            @change="h2hLastChange"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in recentArray"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </h1>
        <div class="mode">
          <span
            :class="h2hMode.includes(2) ? 'active' : ''"
            @click="h2hFilter(2)"
            >{{ langConfig.details[langConfig.curLang]['H2H']['HOME_VS_AWAY'] }}</span
          >
        </div>
        <div
          class="h2h-handicap-statistics-warp"
          v-if="h2hHandicapStatisticsData.reduce((t, v) => t + v.value, 0) > 0"
        >
          <div class="flex progress-bar">
            <div
              :class="'progress-' + item.key"
              :style="{ width: item.rate + '%' }"
              v-for="item in h2hHandicapStatisticsData"
              :key="item.key"
            ></div>
          </div>
          <div class="flex flex-pack-justify handicap-statistics">
            <div
              class="flex"
              v-for="item in h2hHandicapStatisticsData"
              :key="item.key"
            >
              <div class="number" :class="item.key">{{ item.value }}</div>
              <div class="flex flex-align-center flex-v">
                <div class="label">{{ item.label }}</div>
                <div class="value">{{ item.rate }}%</div>
              </div>
            </div>
          </div>
        </div>
        <div class="record-list">
          <div
            class="record-item"
            v-for="item in recentTwentyH2h"
            :key="item.key"
          >
            <div class="item-head">
              <div class="countryFlag">
                <img
                  :src="
                    common.countryDataImgGet(
                      leagueObj[item.leagueId]['country']['id']
                    )
                  "
                  @error="common.imgError($event, 'country')"
                />
              </div>
              <div class="leagueName">
                {{
                  leagueObj[item.leagueId]["shortName"] ||
                  leagueObj[item.leagueId]["fullName"]
                }}
              </div>
              <div class="HT">{{ langConfig.details[langConfig.curLang]['H2H']['HT'] }}</div>
              <div class="FT">{{ langConfig.details[langConfig.curLang]['H2H']['FT'] }}</div>
              <div class="AH">{{ langConfig.details[langConfig.curLang]['H2H']['AH'] }}</div>
              <div class="OU">{{ langConfig.details[langConfig.curLang]['H2H']['OU'] }}</div>
            </div>
            <div
              class="item-row"
              v-for="matchItem in item.match"
              :key="item.leagueId + matchItem.matchId"
              :data-matchid="matchItem.matchId"
            >
              <div class="item-date">
                {{ dataTimeRe(matchItem.startTime) }}
              </div>
              <div class="h2h-team-name-home">
                <span>{{
                  matchItem["homeTeam"]["shortName"] ||
                  matchItem["homeTeam"]["fullName"]
                }}</span>
              </div>
              <div class="h2h-team-name-away">
                <span>{{
                  matchItem["awayTeam"]["shortName"] ||
                  matchItem["awayTeam"]["fullName"]
                }}</span>
              </div>
              <div class="HT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="HT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="FT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div class="FT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div
                class="AH-value"
                :class="
                  'text-color-' + resultFn_Class('AH', asianLuck[matchItem.matchId])
                "
              >
                {{ isItem(asianLuck[matchItem.matchId], "hand", 1) }}
              </div>
              <div
                class="AH-result"
                :class="
                  'text-color-' + resultFn_Class('AH', asianLuck[matchItem.matchId])
                "
              >
                {{ resultFn("AH", asianLuck[matchItem.matchId]) }}
              </div>
              <div
                class="OU-value"
                :class="
                  'text-color-' + resultFn_Class('OU', totalLuck[matchItem.matchId])
                "
              >
                {{ isItem(totalLuck[matchItem.matchId], "total", 1) }}
              </div>
              <div
                class="OU-result"
                :class="
                  'text-color-' + resultFn_Class('OU', totalLuck[matchItem.matchId])
                "
              >
                {{ resultFn("OU", totalLuck[matchItem.matchId]) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 近期战绩 -->
      <div
        class="warp-item"
        v-if="
          recentTwentyHomeOriginData.length ||
          recentTwentyAwayOriginData.length ||
          sameLuckHomeOriginData.length ||
          sameLuckAwayOriginData.length
        "
      >
        <template
          v-if="
            recentTwentyHomeOriginData.length ||
            recentTwentyAwayOriginData.length
          "
        >
          <h1 class="flex flex-pack-justify">
            <div>{{ langConfig.details[langConfig.curLang]['H2H']['RECENT_RECORD'] }}</div>
            <el-select
              v-model="recordLastSelected"
              placeholder="请选择"
              @change="recordLastChange"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in recentArray"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </h1>
          <div class="mode">
            <span
              :class="recordMode.includes(2) ? 'active' : ''"
              @click="recordFilter(2)"
              >{{ langConfig.details[langConfig.curLang]['H2H']['HOME_VS_AWAY'] }}</span
            >
            <span
              :class="recordMode.includes(3) ? 'active' : ''"
              @click="recordFilter(3)"
              >{{ langConfig.details[langConfig.curLang]['H2H']['COMPETION'] }}</span
            >
          </div>
          <!-- 统计 -->
          <div class="statistics-warp">
            <div
              class="statistics-item flex flex-pack-justify flex-align-center"
              v-for="item in recordStatisticsData"
              :key="item.key"
            >
              <div
                class="value"
                :class="
                  ['L', 'goalConcededPerGame', 'Lose'].includes(item.key)
                    ? item.homeTeam.value < item.awayTeam.value
                      ? 'leftActive'
                      : ''
                    : item.homeTeam.value > item.awayTeam.value
                    ? 'leftActive'
                    : ''
                "
              >
                {{ item.homeTeam.value }}
              </div>
              <div class="label flex-1">{{ item.label }}</div>
              <div
                class="value"
                :class="
                  ['L', 'goalConcededPerGame', 'Lose'].includes(item.key)
                    ? item.awayTeam.value < item.homeTeam.value
                      ? 'rightActive'
                      : ''
                    : item.awayTeam.value > item.homeTeam.value
                    ? 'rightActive'
                    : ''
                "
              >
                {{ item.awayTeam.value }}
              </div>
            </div>
          </div>
        </template>
        <template
          v-if="sameLuckHomeOriginData.length || sameLuckAwayOriginData.length"
        >
          <h1 class="flex flex-pack-justify">
            <div>{{ langConfig.details[langConfig.curLang]['H2H']['INDENTICAL_LINES'] }}</div>
            <el-select
              v-model="sameHistoryLastSelected"
              placeholder="请选择"
              @change="sameHistoryLastChange"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in recentArray"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </h1>
          <!-- 历史盘统计 -->
          <div
            class="statistics-warp"
            v-if="
              sameLuckHomeOriginData.length || sameLuckAwayOriginData.length
            "
          >
            <div
              class="statistics-item flex flex-pack-justify flex-align-center"
              v-for="item in sameLuckStatisticsData"
              :key="item.key"
            >
              <div
                class="value"
                :class="
                  ['Lost'].includes(item.key)
                    ? item.homeTeam.value < item.awayTeam.value
                      ? 'leftActive'
                      : ''
                    : item.homeTeam.value > item.awayTeam.value
                    ? 'leftActive'
                    : ''
                "
              >
                {{ item.homeTeam.value }}
              </div>
              <div
                class="label flex-1 flex flex-pack-justify flex-align-center"
              >
                <div class="rate">{{ item.homeTeam.rate }}%</div>
                <div class="flex-1">{{ item.label }}</div>
                <div class="rate">{{ item.awayTeam.rate }}%</div>
              </div>
              <div
                class="value"
                :class="
                  ['Lost'].includes(item.key)
                    ? item.awayTeam.value < item.homeTeam.value
                      ? 'rightActive'
                      : ''
                    : item.awayTeam.value > item.homeTeam.value
                    ? 'rightActive'
                    : ''
                "
              >
                {{ item.awayTeam.value }}
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 主队近期战绩 -->
      <div class="warp-item" :class="recentTwentyAwayOriginData.length? 'connect' : ''" v-if="recentTwentyHomeOriginData.length">
        <h1>
          {{ langConfig.details[langConfig.curLang]['H2H']['TEAM_RECENT_RECORD'].replace('?1', match["homeTeam"]["shortName"] || match["homeTeam"]["fullName"]) }}
        </h1>
        <div class="record-list">
          <div
            class="record-item"
            v-for="item in recentTwentyHome"
            :key="item.key"
          >
            <div class="item-head">
              <div class="countryFlag">
                <img
                  :src="
                    common.countryDataImgGet(
                      leagueObj[item.leagueId]['country']['id']
                    )
                  "
                  @error="common.imgError($event, 'country')"
                />
              </div>
              <div class="leagueName">
                {{
                  leagueObj[item.leagueId]["shortName"] ||
                  leagueObj[item.leagueId]["fullName"]
                }}
              </div>
              <div class="HT">{{ langConfig.details[langConfig.curLang]['H2H']['HT'] }}</div>
              <div class="FT">{{ langConfig.details[langConfig.curLang]['H2H']['FT'] }}</div>
              <div class="AH">{{ langConfig.details[langConfig.curLang]['H2H']['AH'] }}</div>
              <div class="OU">{{ langConfig.details[langConfig.curLang]['H2H']['OU'] }}</div>
              <div class="result"></div>
            </div>
            <div
              class="item-row"
              v-for="matchItem in item.match"
              :key="item.leagueId + matchItem.matchId"
            >
              <div class="item-date">
                {{ dataTimeRe(matchItem.startTime) }}
              </div>
              <div
                class="h2h-team-name-home"
                :class="
                  match.homeTeam.id == matchItem.homeTeam.id
                    ? 'text-color-' +
                    matchResultFn_Class(matchItem.homeLive, matchItem.awayLive)
                    : ''
                "
              >
                <span>{{
                  matchItem["homeTeam"]["shortName"] ||
                  matchItem["homeTeam"]["fullName"]
                }}</span>
              </div>
              <div
                class="h2h-team-name-away"
                :class="
                  match.homeTeam.id == matchItem.awayTeam.id
                    ? 'text-color-' +
                    matchResultFn_Class(matchItem.awayLive, matchItem.homeLive)
                    : ''
                "
              >
                <span>{{
                  matchItem["awayTeam"]["shortName"] ||
                  matchItem["awayTeam"]["fullName"]
                }}</span>
              </div>
              <div class="HT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="HT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="FT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div class="FT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div
                class="AH-value"
                :class="
                  'text-color-' +
                  resultFn_Class('AH', asianLuckHomeResult[matchItem.matchId])
                "
              >
                {{ isItem(asianLuckHomeResult[matchItem.matchId], "hand", 1) }}
              </div>
              <div
                class="AH-result"
                :class="
                  'text-color-' +
                  resultFn_Class('AH', asianLuckHomeResult[matchItem.matchId])
                "
              >
                {{ resultFn("AH", asianLuckHomeResult[matchItem.matchId]) }}
              </div>
              <div
                class="OU-value"
                :class="
                  'text-color-' +
                  resultFn_Class('OU', totalLuckHomeResult[matchItem.matchId])
                "
              >
                {{ isItem(totalLuckHomeResult[matchItem.matchId], "total", 1) }}
              </div>
              <div
                class="OU-result"
                :class="
                  'text-color-' +
                  resultFn_Class('OU', totalLuckHomeResult[matchItem.matchId])
                "
              >
                {{ resultFn("OU", totalLuckHomeResult[matchItem.matchId]) }}
              </div>
              <div class="item-result">
                <div
                  class="record-result"
                  :class="
                    match.homeTeam.id == matchItem.homeTeam.id
                      ? matchResultFn_Class(matchItem.homeLive, matchItem.awayLive)
                      : matchResultFn_Class(matchItem.awayLive, matchItem.homeLive)
                  "
                >
                  {{
                    match.homeTeam.id == matchItem.homeTeam.id
                      ? matchResultFn(matchItem.homeLive, matchItem.awayLive)
                      : matchResultFn(matchItem.awayLive, matchItem.homeLive)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 客队近期战绩 -->
      <div class="warp-item" v-if="recentTwentyAwayOriginData.length">
        <h1>
          {{ langConfig.details[langConfig.curLang]['H2H']['TEAM_RECENT_RECORD'].replace('?1', match["awayTeam"]["shortName"] || match["awayTeam"]["fullName"]) }}
        </h1>
        <div class="record-list">
          <div
            class="record-item"
            v-for="item in recentTwentyAway"
            :key="item.key"
          >
            <div class="item-head">
              <div class="countryFlag">
                <img
                  :src="
                    common.countryDataImgGet(
                      leagueObj[item.leagueId]['country']['id']
                    )
                  "
                  @error="common.imgError($event, 'country')"
                />
              </div>
              <div class="leagueName">
                {{
                  leagueObj[item.leagueId]["shortName"] ||
                  leagueObj[item.leagueId]["fullName"]
                }}
              </div>
              <div class="HT">{{ langConfig.details[langConfig.curLang]['H2H']['HT'] }}</div>
              <div class="FT">{{ langConfig.details[langConfig.curLang]['H2H']['FT'] }}</div>
              <div class="AH">{{ langConfig.details[langConfig.curLang]['H2H']['AH'] }}</div>
              <div class="OU">{{ langConfig.details[langConfig.curLang]['H2H']['OU'] }}</div>
              <div class="result"></div>
            </div>
            <div
              class="item-row"
              v-for="matchItem in item.match"
              :key="item.leagueId + matchItem.matchId"
            >
              <div class="item-date">
                {{ dataTimeRe(matchItem.startTime) }}
              </div>
              <div
                class="h2h-team-name-home"
                :class="
                  match.awayTeam.id == matchItem.homeTeam.id
                    ? 'text-color-' +
                    matchResultFn_Class(matchItem.homeLive, matchItem.awayLive)
                    : ''
                "
              >
                <span>{{
                  matchItem["homeTeam"]["shortName"] ||
                  matchItem["homeTeam"]["fullName"]
                }}</span>
              </div>
              <div
                class="h2h-team-name-away"
                :class="
                  match.awayTeam.id == matchItem.awayTeam.id
                    ? 'text-color-' +
                    matchResultFn_Class(matchItem.awayLive, matchItem.homeLive)
                    : ''
                "
              >
                <span>{{
                  matchItem["awayTeam"]["shortName"] ||
                  matchItem["awayTeam"]["fullName"]
                }}</span>
              </div>
              <div class="HT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="HT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="FT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div class="FT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div
                class="AH-value"
                :class="
                  'text-color-' +
                  resultFn_Class('AH', asianLuckAwayResult[matchItem.matchId])
                "
              >
                {{ isItem(asianLuckAwayResult[matchItem.matchId], "hand", 1) }}
              </div>
              <div
                class="AH-result"
                :class="
                  'text-color-' +
                  resultFn_Class('AH', asianLuckAwayResult[matchItem.matchId])
                "
              >
                {{ resultFn("AH", asianLuckAwayResult[matchItem.matchId]) }}
              </div>
              <div
                class="OU-value"
                :class="
                  'text-color-' +
                  resultFn_Class('OU', totalLuckAwayResult[matchItem.matchId])
                "
              >
                {{ isItem(totalLuckAwayResult[matchItem.matchId], "total", 1) }}
              </div>
              <div
                class="OU-result"
                :class="
                  'text-color-' +
                  resultFn_Class('OU', totalLuckAwayResult[matchItem.matchId])
                "
              >
                {{ resultFn("OU", totalLuckAwayResult[matchItem.matchId]) }}
              </div>
              <div class="item-result">
                <div
                  class="record-result"
                  :class="
                    match.awayTeam.id == matchItem.homeTeam.id
                      ? matchResultFn_Class(matchItem.homeLive, matchItem.awayLive)
                      : matchResultFn_Class(matchItem.awayLive, matchItem.homeLive)
                  "
                >
                  {{
                    match.awayTeam.id == matchItem.homeTeam.id
                      ? matchResultFn(matchItem.homeLive, matchItem.awayLive)
                      : matchResultFn(matchItem.awayLive, matchItem.homeLive)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 主队同盘比赛 -->
      <div class="warp-item" :class="sameLuckAwayOriginData.length? 'connect' : ''" v-if="sameLuckHomeOriginData.length">
        <h1>
          {{ langConfig.details[langConfig.curLang]['H2H']['TEAM_INDENTICAL_LINES'].replace('?1', match["homeTeam"]["shortName"] || match["homeTeam"]["fullName"]) }}
        </h1>
        <div class="record-list">
          <div
            class="record-item"
            v-for="(item, index) in sameLuckHome"
            :key="item.key"
          >
            <div class="item-head sameLuck">
              <div class="countryFlag">
                <img
                  :src="
                    common.countryDataImgGet(
                      leagueObj[item.leagueId]['country']['id']
                    )
                  "
                  @error="common.imgError($event, 'country')"
                />
              </div>
              <div class="leagueName">
                {{
                  leagueObj[item.leagueId]["shortName"] ||
                  leagueObj[item.leagueId]["fullName"]
                }}
              </div>
              <div class="HT">{{ langConfig.details[langConfig.curLang]['H2H']['HT'] }}</div>
              <div class="FT">{{ langConfig.details[langConfig.curLang]['H2H']['FT'] }}</div>
              <div
                v-if="
                  index == 0 &&
                  isItem(
                    asianSameLuckHomeResult[item.match[0].matchId],
                    'handInit',
                    1
                  )
                "
              >
              {{ langConfig.details[langConfig.curLang]['H2H']['INITIAL_ODDS'] }}:
                {{
                  isItem(
                    asianSameLuckHomeResult[item.match[0].matchId],
                    "handInit",
                    1
                  )
                }}
              </div>
            </div>
            <div
              class="item-row"
              v-for="matchItem in item.match"
              :key="item.leagueId + matchItem.matchId"
            >
              <div class="item-date">
                {{ dataTimeRe(matchItem.startTime) }}
              </div>
              <div
                class="h2h-team-name-home"
                :class="
                  match.homeTeam.id == matchItem.homeTeam.id
                    ? 'text-color-' +
                    resultFn_Class(
                        'AH',
                        asianSameLuckHomeResult[matchItem.matchId],
                        'resultInit'
                      )
                    : ''
                "
              >
                <span>{{
                  matchItem["homeTeam"]["shortName"] ||
                  matchItem["homeTeam"]["fullName"]
                }}</span>
              </div>
              <div
                class="h2h-team-name-away"
                :class="
                  match.homeTeam.id == matchItem.awayTeam.id
                    ? 'text-color-' +
                    resultFn_Class(
                        'AH',
                        asianSameLuckHomeResult[matchItem.matchId],
                        'resultInit'
                      )
                    : ''
                "
              >
                <span>{{
                  matchItem["awayTeam"]["shortName"] ||
                  matchItem["awayTeam"]["fullName"]
                }}</span>
              </div>
              <div class="HT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="HT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="FT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div class="FT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div class="item-result">
                <div
                  class="record-result"
                  :class="
                  resultFn_Class(
                      'AH',
                      asianSameLuckHomeResult[matchItem.matchId],
                      'resultInit',
                    )
                  "
                >
                  {{
                    resultFn(
                      "AH",
                      asianSameLuckHomeResult[matchItem.matchId],
                      "resultInit"
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 客队同盘比赛 -->
      <div class="warp-item" v-if="sameLuckAwayOriginData.length">
        <h1>
          {{ langConfig.details[langConfig.curLang]['H2H']['TEAM_INDENTICAL_LINES'].replace('?1', match["awayTeam"]["shortName"] || match["awayTeam"]["fullName"]) }}
        </h1>
        <div class="record-list">
          <div
            class="record-item"
            v-for="(item, index) in sameLuckAway"
            :key="item.key"
          >
            <div class="item-head sameLuck">
              <div class="countryFlag">
                <img
                  :src="
                    common.countryDataImgGet(
                      leagueObj[item.leagueId]['country']['id']
                    )
                  "
                  @error="common.imgError($event, 'country')"
                />
              </div>
              <div class="leagueName">
                {{
                  leagueObj[item.leagueId]["shortName"] ||
                  leagueObj[item.leagueId]["fullName"]
                }}
              </div>
              <div class="HT">{{ langConfig.details[langConfig.curLang]['H2H']['HT'] }}</div>
              <div class="FT">{{ langConfig.details[langConfig.curLang]['H2H']['FT'] }}</div>
              <div
                class=""
                v-if="
                  index == 0 &&
                  isItem(
                    asianSameLuckAwayResult[item.match[0].matchId],
                    'handInit',
                    1
                  )
                "
              >
              {{ langConfig.details[langConfig.curLang]['H2H']['INITIAL_ODDS'] }}:
                {{
                  isItem(
                    asianSameLuckAwayResult[item.match[0].matchId],
                    "handInit",
                    1
                  )
                }}
              </div>
            </div>
            <div
              class="item-row"
              v-for="matchItem in item.match"
              :key="item.leagueId + matchItem.matchId"
            >
              <div class="item-date">
                {{ dataTimeRe(matchItem.startTime) }}
              </div>
              <div
                class="h2h-team-name-home"
                :class="
                  match.awayTeam.id == matchItem.homeTeam.id
                    ? 'text-color-' +
                    resultFn_Class(
                        'AH',
                        asianSameLuckAwayResult[matchItem.matchId],
                        'resultInit'
                      )
                    : ''
                "
              >
                <span>{{
                  matchItem["homeTeam"]["shortName"] ||
                  matchItem["homeTeam"]["fullName"]
                }}</span>
              </div>
              <div
                class="h2h-team-name-away"
                :class="
                  match.awayTeam.id == matchItem.awayTeam.id
                    ? 'text-color-' +
                    resultFn_Class(
                        'AH',
                        asianSameLuckAwayResult[matchItem.matchId],
                        'resultInit'
                      )
                    : ''
                "
              >
                <span>{{
                  matchItem["awayTeam"]["shortName"] ||
                  matchItem["awayTeam"]["fullName"]
                }}</span>
              </div>
              <div class="HT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="HT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreHalf"
                  )
                }}
              </div>
              <div class="FT-home">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["homeLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div class="FT-away">
                {{
                  scoreCallFn(
                    matchItem.state,
                    matchItem["awayLive"],
                    "scoreFull"
                  )
                }}
              </div>
              <div class="item-result">
                <div
                  class="record-result"
                  :class="
                  resultFn_Class(
                      'AH',
                      asianSameLuckAwayResult[matchItem.matchId],
                      'resultInit',
                    )
                  "
                >
                  {{
                    resultFn(
                      "AH",
                      asianSameLuckAwayResult[matchItem.matchId],
                      "resultInit"
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 未来三场 -->
      <div
        class="warp-item"
        v-if="match.state != 4 && (fixtureHome.length || fixtureAway.length)"
      >
        <h1>{{ langConfig.details[langConfig.curLang]['H2H']['UPCOMING_GAMES'] }}</h1>
        <div class="record-list">
          <div class="record-item">
            <div class="item-head fixture">
              <div>
                {{
                  match["homeTeam"]["shortName"] ||
                  match["homeTeam"]["fullName"]
                }}
              </div>
            </div>
            <div
              class="item-row fixture"
              v-for="item in fixtureHome"
              :key="item.matchId"
            >
              <div class="fixture-league-name">
                {{
                  leagueObj[item.leagueId]["shortName"] ||
                  leagueObj[item.leagueId]["fullName"]
                }}
              </div>
              <div class="match-date">
                {{ common.dateStr(item.startTime, "dd/MM YYYY") }}
              </div>
              <div class="fixture-team-name-home">
                <span
                  :class="
                    match.homeTeam.id == item.homeTeam.id ? 'home-color' : ''
                  "
                  >{{
                    item["homeTeam"]["shortName"] ||
                    item["homeTeam"]["fullName"]
                  }}</span
                >
              </div>
              <div class="fixture-team-name-away">
                <span
                  :class="
                    match.homeTeam.id == item.awayTeam.id ? 'home-color' : ''
                  "
                  >{{
                    item["awayTeam"]["shortName"] ||
                    item["awayTeam"]["fullName"]
                  }}</span
                >
              </div>
              <div class="fixture-date">{{ langConfig.details[langConfig.curLang]['H2H']['DAYS_LATER'].replace('?1', item.daySpan) }}</div>
            </div>
          </div>
        </div>
        <div class="record-list">
          <div class="record-item">
            <div class="item-head fixture">
              <div>
                {{
                  match["awayTeam"]["shortName"] ||
                  match["awayTeam"]["fullName"]
                }}
              </div>
            </div>
            <div
              class="item-row fixture"
              v-for="item in fixtureAway"
              :key="item.matchId"
            >
              <div class="fixture-league-name">
                {{
                  leagueObj[item.leagueId]["shortName"] ||
                  leagueObj[item.leagueId]["fullName"]
                }}
              </div>
              <div class="match-date">
                {{ common.dateStr(item.startTime, "dd/MM YYYY") }}
              </div>
              <div class="fixture-team-name-home">
                <span
                  :class="
                    match.awayTeam.id == item.homeTeam.id ? 'away-color' : ''
                  "
                  >{{
                    item["homeTeam"]["shortName"] ||
                    item["homeTeam"]["fullName"]
                  }}</span
                >
              </div>
              <div class="fixture-team-name-away">
                <span
                  :class="
                    match.awayTeam.id == item.awayTeam.id ? 'away-color' : ''
                  "
                  >{{
                    item["awayTeam"]["shortName"] ||
                    item["awayTeam"]["fullName"]
                  }}</span
                >
              </div>
              <div class="fixture-date">{{ langConfig.details[langConfig.curLang]['H2H']['DAYS_LATER'].replace('?1', item.daySpan) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultPic from "@/components/defaultPic";
import { getMatchH2H } from "@/api/api";
export default {
  components: {
    DefaultPic,
  },
  data() {
    return {
      loading: true,
      baseParam: {
        userToken: "",
      },
      recentArray: [
        { label: this.langConfig.details[this.langConfig.curLang]['H2H']['LAST_GAMES'].replace('?1', 5), value: 5 },
        { label: this.langConfig.details[this.langConfig.curLang]['H2H']['LAST_GAMES'].replace('?1', 10), value: 10 },
        { label: this.langConfig.details[this.langConfig.curLang]['H2H']['LAST_GAMES'].replace('?1', 15), value: 15 },
        { label: this.langConfig.details[this.langConfig.curLang]['H2H']['LAST_GAMES'].replace('?1', 20), value: 20 },
      ],
      h2hLastSelected: 10,
      recordLastSelected: 10,
      sameHistoryLastSelected: 10,
      h2hMode: [], // 1全部 2同主客
      recordMode: [], // 1全部 2同主客 3同联赛
      leagueObj: {},
      recentTwentyH2hOriginData: [],
      recentTwentyHomeOriginData: [],
      recentTwentyAwayOriginData: [],
      sameLuckHomeOriginData: [],
      sameLuckAwayOriginData: [],
      h2hHandicapStatisticsData: [
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['WON'],
          key: "Won",
          value: 0,
          rate: 0,
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['DRAW'],
          key: "Draw",
          value: 0,
          rate: 0,
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['LOST'],
          key: "Lost",
          value: 0,
          rate: 0,
        },
      ],
      recordStatisticsData: [
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['W'],
          key: "W",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['D'],
          key: "D",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['L'],
          key: "L",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['GOAL_SCORED'],
          key: "goalScored",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['GOAL_CONCEDED'],
          key: "goalConcededPerGame",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['CLEAN_SHEETS'],
          key: "cleanSheets",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['WIN'],
          key: "Win",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['PUSH'],
          key: "Push",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['LOSE'],
          key: "Lose",
          homeTeam: { value: 0 },
          awayTeam: { value: 0 },
        },
      ],
      sameLuckStatisticsData: [
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['WON'],
          key: "Won",
          homeTeam: { value: 0, rate: 0 },
          awayTeam: { value: 0, rate: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['DRAW'],
          key: "Draw",
          homeTeam: { value: 0, rate: 0 },
          awayTeam: { value: 0, rate: 0 },
        },
        {
          label: this.langConfig.details[this.langConfig.curLang]['H2H']['LOST'],
          key: "Lost",
          homeTeam: { value: 0, rate: 0 },
          awayTeam: { value: 0, rate: 0 },
        },
      ],
      recentTwentyH2h: [], // 近20场交锋
      recentTwentyHome: [], //近20场主队战绩
      recentTwentyAway: [], //近20场客队战绩
      asianLuck: {}, //亚信息
      totalLuck: {}, //总信息
      asianLuckHomeResult: {}, //亚信息by主队结果
      totalLuckHomeResult: {}, //总信息by主队结果
      asianLuckAwayResult: {}, //亚信息by客队结果
      totalLuckAwayResult: {}, //总信息by客队结果
      sameLuckHome: [], //相同历史盘主队
      sameLuckAway: [], //相同历史盘客队
      asianSameLuckHomeResult: {}, //相同盘口亚信息for主队结果
      asianSameLuckAwayResult: {}, //相同盘口亚信息for客队结果
      fixtureHome: [], //赛程主队
      fixtureAway: [], //赛程客队
    };
  },
  methods: {
    logdingFlag() {
      if (typeof window != "undefined" && this.loading) {
        return true;
      }
      return false;
    },
    //数据读取
    async getMatchH2HData() {
      let obj = {
        matchId: this.matchId,
      };
      var _this = this;
      let param = Object.assign(obj, this.baseParam);
      await getMatchH2H(param)
        .then((res) => {
          this.loading = false;
          let data = JSON.parse(JSON.stringify(res.data));
          // console.log("getMatchH2HData", data);
          if (data) {
            this.dataFormat(data);
          }
        })
        .catch((res) => {
          console.error(res);
        });
    },
    dataFormat(_data) {
      const league = _data["league"] || {};
      const h2hLastSelected = this.h2hLastSelected;
      const recordLastSelected = this.recordLastSelected;
      const sameHistoryLastSelected = this.sameHistoryLastSelected;
      const recentTwentyH2h = _data["recentTwentyH2h"] || []; // 近20场交锋
      const recentTwentyHome = _data["recentTwentyHome"] || []; //近20场主队战绩
      const recentTwentyAway = _data["recentTwentyAway"] || []; //近20场客队战绩
      const asianLuck = _data["asianLuck"] || {}; //亚信息
      const totalLuck = _data["totalLuck"] || {}; //总信息
      const asianLuckHomeResult = _data["asianLuckHomeResult"] || {}; //亚信息by主队结果
      const totalLuckHomeResult = _data["totalLuckHomeResult"] || {}; //总信息by主队结果
      const asianLuckAwayResult = _data["asianLuckAwayResult"] || {}; //亚信息by客队结果
      const totalLuckAwayResult = _data["totalLuckAwayResult"] || {}; //总信息by客队结果
      const sameLuckHome = _data["sameLuckHome"] || []; //相同历史盘主队
      const sameLuckAway = _data["sameLuckAway"] || []; //相同历史盘客队
      const asianSameLuckHomeResult = _data["asianSameLuckHomeResult"] || {}; //相同盘口亚信息for主队结果
      const asianSameLuckAwayResult = _data["asianSameLuckAwayResult"] || {}; //相同盘口亚信息for客队结果
      const fixtureHome = _data["fixtureHome"] || []; //赛程主队
      const fixtureAway = _data["fixtureAway"] || []; //赛程客队
      this.leagueObj = league;
      this.asianLuck = asianLuck;
      this.totalLuck = totalLuck;
      this.asianLuckHomeResult = asianLuckHomeResult;
      this.totalLuckHomeResult = totalLuckHomeResult;
      this.asianLuckAwayResult = asianLuckAwayResult;
      this.totalLuckAwayResult = totalLuckAwayResult;
      this.recentTwentyH2hOriginData = recentTwentyH2h;
      this.recentTwentyH2h = this.matchConformity(
        recentTwentyH2h.slice(0, h2hLastSelected)
      );
      this.recentTwentyHomeOriginData = recentTwentyHome;
      this.recentTwentyAwayOriginData = recentTwentyAway;
      this.recentTwentyHome = this.matchConformity(
        recentTwentyHome.slice(0, recordLastSelected)
      );
      this.recentTwentyAway = this.matchConformity(
        recentTwentyAway.slice(0, recordLastSelected)
      );
      this.sameLuckHomeOriginData = sameLuckHome;
      this.sameLuckAwayOriginData = sameLuckAway;
      this.sameLuckHome = this.matchConformity(
        sameLuckHome.slice(0, sameHistoryLastSelected)
      );
      this.sameLuckAway = this.matchConformity(
        sameLuckAway.slice(0, sameHistoryLastSelected)
      );
      this.asianSameLuckHomeResult = asianSameLuckHomeResult;
      this.asianSameLuckAwayResult = asianSameLuckAwayResult;
      this.fixtureHome = fixtureHome;
      this.fixtureAway = fixtureAway;
      // h2h统计
      this.h2hStatistics();
      // 近期战绩统计
      this.recordStatistics();
      // 相同历史盘统计
      this.sameHistoryHandicapStatistics();
      // console.log("match", this.match);
      // console.log("league", this.league);
    },
    // 同一联赛的比赛整合
    matchConformity(originData) {
      let _obj = {};
      let index = 0;
      let leagueId = "";
      originData.forEach((item) => {
        if (leagueId != item.leagueId) {
          index++;
          leagueId = item.leagueId;
          _obj[index] = {
            key: `${leagueId}-${index}`,
            leagueId,
            match: [item],
          };
        } else {
          _obj[index]["match"].push(item);
        }
      });
      return Object.values(_obj);
    },
    // 是否有数据返回
    isItem(item, key, returnValue = false) {
      if (typeof item != "undefined" && key in item && item[key]) {
        if (returnValue) return item[key];
        else return true;
      }
      return returnValue ? "" : false;
    },
    // 比分返回
    scoreCallFn(state, item, key) {
      if ([4].includes(state)) {
        return item?.[key] || 0;
      } else {
        return "";
      }
    },
    // 胜平负结果
    matchResultFn(aTeam, bTeam) {
      const aScore = aTeam?.scoreFull || 0;
      const bScore = bTeam?.scoreFull || 0;
      if (aScore > bScore) {
        return this.langConfig.details[this.langConfig.curLang]['H2H']['W'];
      } else if (aScore < bScore) {
        return this.langConfig.details[this.langConfig.curLang]['H2H']['L'];
      } else if (aScore == bScore) {
        return this.langConfig.details[this.langConfig.curLang]['H2H']['D'];
      } else {
        return "";
      }
    },
    // 胜平负结果
    matchResultFn_Class(aTeam, bTeam) {
      const aScore = aTeam?.scoreFull || 0;
      const bScore = bTeam?.scoreFull || 0;
      if (aScore > bScore) {
        return this.langConfig.details['en']['H2H']['W'];
      } else if (aScore < bScore) {
        return this.langConfig.details['en']['H2H']['L'];
      } else if (aScore == bScore) {
        return this.langConfig.details['en']['H2H']['D'];
      } else {
        return "";
      }
    },
    // 盘口结果
    resultFn(type, obj, result = "result") {
      if (typeof obj != "undefined" && obj[result]) {
        if (type == "AH") return this.langConfig.details[this.langConfig.curLang]['H2H']['RESULT_ARR'][obj[result]];
        if (type == "OU") return this.langConfig.details[this.langConfig.curLang]['H2H']['RESULT_ARR2'][obj[result]];
      } else {
        return "";
      }
    },
    // 样式的话无需多语种翻译
    resultFn_Class(type, obj, result = "result") {
      if (typeof obj != "undefined" && obj[result]) {
        if (type == "AH") return this.langConfig.details['en']['H2H']['RESULT_ARR'][obj[result]];
        if (type == "OU") return this.langConfig.details['en']['H2H']['RESULT_ARR2'][obj[result]];
      } else {
        return "";
      }
    },
    // h2h统计
    h2hStatistics() {
      const h2hLastSelected = this.h2hLastSelected;
      const h2hMode = this.h2hMode;
      const _h2hHandicapStatisticsData = this.h2hHandicapStatisticsData.map(
        (item) => {
          item.value = 0;
          item.rate = 0;
          return item;
        }
      );
      const _data = this.recentTwentyH2hOriginData
        .filter((item) =>
          h2hMode.includes(2)
            ? item?.homeTeam?.id == this.match?.homeTeam?.id &&
              item?.awayTeam?.id == this.match?.awayTeam?.id
            : true
        )
        .slice(0, h2hLastSelected);
      _data.forEach((match) => {
        _h2hHandicapStatisticsData.map((item) => {
          const aScore = match?.homeLive?.scoreFull ?? 0;
          const bScore = match?.awayLive?.scoreFull ?? 0;
          switch (item.key) {
            case "Won":
              // 胜
              if (this.match?.homeTeam?.id == match?.homeTeam?.id) {
                if (aScore > bScore) item.value += 1;
              } else {
                if (bScore > aScore) item.value += 1;
              }

              break;
            case "Draw":
              // 平
              if (aScore == bScore) item.value += 1;
              break;
            case "Lost":
              // 负
              if (this.match?.homeTeam?.id == match?.homeTeam?.id) {
                if (aScore < bScore) item.value += 1;
              } else {
                if (bScore < aScore) item.value += 1;
              }
              break;
          }
          return item;
        });
      });
      this.h2hHandicapStatisticsData = _h2hHandicapStatisticsData.map(
        (item) => {
          item.rate = ((item.value * 100) / (_data.length || 1))
            .toFixed(1)
            .replace(/\.00*/gi, "");
          return item;
        }
      );
      // console.log(this.h2hHandicapStatisticsData);
    },
    // 近期战绩统计
    recordStatistics() {
      const recordMode = this.recordMode;
      const recordLastSelected = this.recordLastSelected;
      const homeTeamData = this.recentTwentyHomeOriginData
        .filter((item) =>
          recordMode.includes(2)
            ? item?.homeTeam?.id == this.match?.homeTeam?.id
            : true
        )
        .filter((item) =>
          recordMode.includes(3) ? item?.leagueId == this.league?.id : true
        )
        .slice(0, recordLastSelected);
      const awayTeamData = this.recentTwentyAwayOriginData
        .filter((item) =>
          recordMode.includes(2)
            ? item?.awayTeam?.id == this.match?.awayTeam?.id
            : true
        )
        .filter((item) =>
          recordMode.includes(3) ? item?.leagueId == this.league?.id : true
        )
        .slice(0, recordLastSelected);
      const _recordStatisticsData = this.recordStatisticsData.map((item) => {
        item.homeTeam.value = 0;
        item.awayTeam.value = 0;
        return item;
      });
      homeTeamData.forEach((match) => {
        const _asian = this.asianLuckHomeResult[match.matchId];
        const aScore = match?.["homeLive"]?.["scoreFull"] ?? 0;
        const bScore = match?.["awayLive"]?.["scoreFull"] ?? 0;

        _recordStatisticsData.map((item) => {
          switch (item.key) {
            case "W":
              // 胜
              if (this.match?.homeTeam?.id == match?.homeTeam?.id) {
                if (aScore > bScore) item.homeTeam.value += 1;
              } else {
                if (bScore > aScore) item.homeTeam.value += 1;
              }

              break;
            case "D":
              // 平
              if (aScore == bScore) item.homeTeam.value += 1;
              break;
            case "L":
              // 负
              if (this.match?.homeTeam?.id == match?.homeTeam?.id) {
                if (aScore < bScore) item.homeTeam.value += 1;
              } else {
                if (bScore < aScore) item.homeTeam.value += 1;
              }
              break;
            case "goalScored":
              // 场均进球
              item.homeTeam.value +=
                (this.match?.homeTeam?.id == match?.homeTeam?.id
                  ? match?.["homeLive"]?.["scoreFull"] ?? 0
                  : match?.["awayLive"]?.["scoreFull"] ?? 0) /
                homeTeamData.length;
              break;
            case "goalConcededPerGame":
              // 场均丢球
              item.homeTeam.value +=
                (this.match?.homeTeam?.id == match?.homeTeam?.id
                  ? match?.["awayLive"]?.["scoreFull"] ?? 0
                  : match?.["homeLive"]?.["scoreFull"] ?? 0) /
                homeTeamData.length;
              break;
            case "cleanSheets":
              // 零封场次
              if (
                (this.match?.homeTeam?.id == match?.homeTeam?.id &&
                  !match?.["awayLive"]?.["scoreFull"]) ||
                (this.match?.homeTeam?.id == match?.awayTeam?.id &&
                  !match?.["homeLive"]?.["scoreFull"])
              )
                item.homeTeam.value += 1;
              break;
            case "Win":
              // 赢盘
              if (_asian?.["result"] == 1) item.homeTeam.value += 1;
              break;
            case "Push":
              // 平盘
              if (_asian?.["result"] == 5) item.homeTeam.value += 1;
              break;
            case "Lose":
              // 输盘
              if (_asian?.["result"] == 3) item.homeTeam.value += 1;
              break;
          }
          return item;
        });
      });
      awayTeamData.forEach((match) => {
        const _asian = this.asianLuckAwayResult[match.matchId];
        const aScore = match?.["homeLive"]?.["scoreFull"] ?? 0;
        const bScore = match?.["awayLive"]?.["scoreFull"] ?? 0;
        _recordStatisticsData.map((item) => {
          switch (item.key) {
            case "W":
              // 胜
              if (this.match?.awayTeam?.id == match?.homeTeam?.id) {
                if (aScore > bScore) item.awayTeam.value += 1;
              } else {
                if (bScore > aScore) item.awayTeam.value += 1;
              }

              break;
            case "D":
              // 平
              if (aScore == bScore) item.awayTeam.value += 1;
              break;
            case "L":
              // 负
              if (this.match?.awayTeam?.id == match?.homeTeam?.id) {
                if (aScore < bScore) item.awayTeam.value += 1;
              } else {
                if (bScore < aScore) item.awayTeam.value += 1;
              }
              break;
            case "goalScored":
              // 场均进球
              item.awayTeam.value +=
                (this.match?.awayTeam?.id == match?.homeTeam?.id
                  ? match?.["homeLive"]?.["scoreFull"] ?? 0
                  : match?.["awayLive"]?.["scoreFull"] ?? 0) /
                awayTeamData.length;
              break;
            case "goalConcededPerGame":
              // 场均丢球
              item.awayTeam.value +=
                (this.match?.awayTeam?.id == match?.homeTeam?.id
                  ? match?.["awayLive"]?.["scoreFull"] ?? 0
                  : match?.["homeLive"]?.["scoreFull"] ?? 0) /
                awayTeamData.length;
              break;
            case "cleanSheets":
              // 零封场次
              if (
                (this.match?.awayTeam?.id == match?.homeTeam?.id &&
                  !match?.["awayLive"]?.["scoreFull"]) ||
                (this.match?.awayTeam?.id == match?.awayTeam?.id &&
                  !match?.["homeLive"]?.["scoreFull"])
              )
                item.awayTeam.value += 1;
              break;
            case "Win":
              // 赢盘
              if (_asian?.["result"] == 1) item.awayTeam.value += 1;
              break;
            case "Push":
              // 平盘
              if (_asian?.["result"] == 5) item.awayTeam.value += 1;
              break;
            case "Lose":
              // 输盘
              if (_asian?.["result"] == 3) item.awayTeam.value += 1;
              break;
          }
          return item;
        });
      });
      this.recordStatisticsData = _recordStatisticsData.map((item) => {
        if (["goalScored", "goalConcededPerGame"].includes(item.key)) {
          const homeValue = +item.homeTeam.value;
          const awayValue = +item.awayTeam.value;
          item.homeTeam.value = homeValue.toFixed(1).replace(/\.00*/gi, "");
          item.awayTeam.value = awayValue.toFixed(1).replace(/\.00*/gi, "");
        }
        return item;
      });
    },
    // 相同历史盘统计
    sameHistoryHandicapStatistics() {
      const sameHistoryLastSelected = this.sameHistoryLastSelected;
      const homeTeamData = this.sameLuckHomeOriginData.slice(
        0,
        sameHistoryLastSelected
      );
      const awayTeamData = this.sameLuckAwayOriginData.slice(
        0,
        sameHistoryLastSelected
      );
      const _sameLuckStatisticsData = this.sameLuckStatisticsData.map(
        (item) => {
          item.homeTeam.value = 0;
          item.homeTeam.rate = 0;
          item.awayTeam.value = 0;
          item.awayTeam.rate = 0;
          return item;
        }
      );
      homeTeamData.forEach((match) => {
        const _asian = this.asianSameLuckHomeResult[match.matchId];
        _sameLuckStatisticsData.map((item) => {
          switch (item.key) {
            case "Won":
              // 赢盘
              if (_asian?.["resultInit"] == 1) item.homeTeam.value += 1;
              break;
            case "Draw":
              // 平盘
              if (_asian?.["resultInit"] == 5) item.homeTeam.value += 1;
              break;
            case "Lost":
              // 输盘
              if (_asian?.["resultInit"] == 3) item.homeTeam.value += 1;
              break;
          }
          return item;
        });
      });
      awayTeamData.forEach((match) => {
        const _asian = this.asianSameLuckAwayResult[match.matchId];
        _sameLuckStatisticsData.map((item) => {
          switch (item.key) {
            case "Won":
              // 赢盘
              if (_asian?.["resultInit"] == 1) item.awayTeam.value += 1;
              break;
            case "Draw":
              // 平盘
              if (_asian?.["resultInit"] == 5) item.awayTeam.value += 1;
              break;
            case "Lost":
              // 输盘
              if (_asian?.["resultInit"] == 3) item.awayTeam.value += 1;
              break;
          }
          return item;
        });
      });
      this.sameLuckStatisticsData = _sameLuckStatisticsData.map((item) => {
        const homeValue = +item.homeTeam.value;
        const awayValue = +item.awayTeam.value;
        item.homeTeam.rate = ((homeValue * 100) / (homeTeamData.length || 1))
          .toFixed(1)
          .replace(/\.00*/gi, "");
        item.awayTeam.rate = ((awayValue * 100) / (awayTeamData.length || 1))
          .toFixed(1)
          .replace(/\.00*/gi, "");
        return item;
      });
      // console.log("sameLuckStatisticsData", this.sameLuckStatisticsData);
    },
    // h2h 近几场切换
    h2hLastChange(value) {
      // 近几场切换
      const _recentTwentyH2h = this.recentTwentyH2hOriginData;
      this.h2hLastSelected = value;
      this.recentTwentyH2h = this.matchConformity(
        _recentTwentyH2h
          .filter((item) =>
            this.h2hMode.includes(2)
              ? item?.homeTeam?.id == this.match?.homeTeam?.id &&
                item?.awayTeam?.id == this.match?.awayTeam?.id
              : true
          )
          .slice(0, value)
      );
      this.h2hStatistics();
    },
    // h2h筛选 1全部 2同主客
    h2hFilter(type) {
      if (this.h2hMode.includes(type)) {
        this.h2hMode = this.h2hMode.filter((_type) => _type != type);
      } else {
        this.h2hMode.push(type);
      }

      const _data = this.recentTwentyH2hOriginData;
      if (this.h2hMode.includes(2)) {
        // 同主客
        const _list = _data
          .filter(
            (item) =>
              item?.homeTeam?.id == this.match?.homeTeam?.id &&
              item?.awayTeam?.id == this.match?.awayTeam?.id
          )
          .slice(0, this.h2hLastSelected);
        this.recentTwentyH2h = this.matchConformity(_list);
      } else {
        this.recentTwentyH2h = this.matchConformity(
          _data.slice(0, this.h2hLastSelected)
        );
      }
      this.h2hStatistics();
    },
    // 近期战绩 近几场切换
    recordLastChange(value) {
      // 近几场切换
      const recordMode = this.recordMode;
      this.recordLastSelected = value;
      this.recentTwentyHome = this.matchConformity(
        this.recentTwentyHomeOriginData
          .filter((item) =>
            recordMode.includes(2)
              ? item?.homeTeam?.id == this.match?.homeTeam?.id
              : true
          )
          .filter((item) =>
            recordMode.includes(3) ? item?.leagueId == this.league?.id : true
          )
          .slice(0, value)
      );
      this.recentTwentyAway = this.matchConformity(
        this.recentTwentyAwayOriginData
          .filter((item) =>
            recordMode.includes(2)
              ? item?.awayTeam?.id == this.match?.awayTeam?.id
              : true
          )
          .filter((item) =>
            recordMode.includes(3) ? item?.leagueId == this.league?.id : true
          )
          .slice(0, value)
      );
      this.recordStatistics();
    },
    // 近期战绩筛选 1全部 2同主客 3同赛事
    recordFilter(type) {
      if (this.recordMode.includes(type)) {
        this.recordMode = this.recordMode.filter((_type) => _type != type);
      } else {
        this.recordMode.push(type);
      }
      this.recordLastChange(this.recordLastSelected);
    },
    // 相同盘路 近几场切换
    sameHistoryLastChange(value) {
      // 近几场切换
      this.sameHistoryLastSelected = value;
      this.sameLuckHome = this.matchConformity(
        this.sameLuckHomeOriginData.slice(0, value)
      );
      this.sameLuckAway = this.matchConformity(
        this.sameLuckAwayOriginData.slice(0, value)
      );
      this.sameHistoryHandicapStatistics();
    },
    // 日期返回
    dataTimeRe(val){
      var _dateForm = 'dd/MM YYYY';

      if(this.langConfig.curLang == 'kr'){
        _dateForm = 'MM-dd YYYY';
      }

      var _time=this.common.dateStr(val,_dateForm);
      return _time;
    },
    init() {
      if (!this.matchId) {
        return;
      }
      this.getMatchH2HData();
    },
  },
  created() {
    this.init();
  },
  watch: {
    matchId() {
      this.init();
    },
  },
  mounted() {},
  beforeDestroy() {},
  props: {
    //联赛信息
    league: {
      type: Object,
      default: null,
    },
    //比赛信息
    match: {
      type: Object,
      default: null,
    },
    //比赛ID
    matchId: {
      type: Number,
      default: null,
    },
  },
};
</script>


// WEBPACK FOOTER //
// ./src/views/details/components/detailsH2H.vue